import moment from 'moment';

import config from '@config';
import { actions } from '@store/actions/ux';
import { getCookie } from '@themejs/helpers/cookies';

const locationHost = window.location.host;

if (locationHost.indexOf('freely') > -1) {
  config.defaultNID = config.defaultNIDFreely;
}

const initialState = {
  nid: getCookie(config.cookies.nidCookieName) || config.defaultNID,
  postcode: getCookie(config.cookies.postcodeCookieName) || null,
  minutesPixelRatio: 3,
  pixelRatioChanged: false,
  view: 'grid',
  selectedChannel: null,
  detailPanel: {
    display: false,
    id: null,
    bypass: false,
  },
  load: {
    programs: false,
    searchTvguide: false,
    searchCatchup: false,
  },
  accessibilities: [
    {
      name: 'S',
      propertyName: 'subtitles',
      value: false,
    },
    {
      name: 'AD',
      propertyName: 'audio_description',
      value: false,
    },
    {
      name: 'SL',
      propertyName: 'signing',
      value: false,
    },
  ],
  highlights: [
    {
      name: 'Movies',
      value: false,
      color: '#3EC0EE',
      freelyColor: '#7f7eff',
      mdsGenre: 'urn:fvc:metadata:cs:ContentSubjectCS:2014-07:1',
    },
    {
      name: 'Sport',
      value: false,
      color: '#00B502',
      freelyColor: '#67d8d8',
      mdsGenre: 'urn:fvc:metadata:cs:ContentSubjectCS:2014-07:4',
    },
  ],
  isLoadingTvguide: false,
  isDST: moment().isDST(),
  activeDay: moment().format('YYYY-MM-DD'),
  beginDate: moment()
    .subtract(config.maxDaysDiff, 'days')
    .format('YYYY-MM-DD'),
  endDate: moment()
    .add(config.maxDaysDiff, 'days')
    .format('YYYY-MM-DD'),
  displayedTime: {
    start: null,
    end: null,
  },
  searchQuery: '',
};

const channels = (state = initialState, action) => {
  switch (action.type) {
    case actions.set:
      return {
        ...state,
        ...action.prop,
      };
    case actions.reset:
      return initialState;
    case actions.showDetailPanel:
      state.detailPanel.display = true;
      return { ...state };
    case actions.hideDetailPanel:
      state.detailPanel.display = false;
      return { ...state };
    case actions.bypassDetailPanel:
      state.detailPanel.bypass = true;
      return { ...state };
    case actions.setLoad:
      state.load = {
        ...state.load,
        ...action.prop,
      };
      return { ...state };
    case actions.setHighlight:
      const highlights = [...state.highlights];
      const updateIndex = highlights.findIndex(
        el => el.name === action.prop.name,
      );

      highlights[updateIndex].value = action.prop.value;
      return {
        ...state,
        highlights: highlights,
      };
    case actions.clearLocation:
      return {
        ...state,
        nid: config.defaultNID,
        postcode: null,
      };
    case actions.setAccessiblity:
      const accessibilities = [...state.accessibilities];
      const accUpdateIndex = accessibilities.findIndex(
        el => el.name === action.prop.name,
      );

      accessibilities[accUpdateIndex].value = action.prop.value;
      return {
        ...state,
        accessibilities: accessibilities,
      };
    default:
      return state;
  }
};

export default channels;
